// extracted by mini-css-extract-plugin
export default {"cardDeatail":"CardDetail_cardDeatail__5FPcs","text":"CardDetail_text__mUrtb","item-image":"CardDetail_item-image__YOM7C","header":"CardDetail_header__81phW"};